"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fetchClient = require("@nike/fetch-client");
var _uxTreadDotcomConstants = require("@nike/ux-tread-dotcom-constants");
var _getQueryKey = _interopRequireDefault(require("../../get-query-key"));
var _getQueryKey2 = _interopRequireDefault(require("../summary/get-query-key"));
var _getOptions = require("../../../fetch-default-list/get-options");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var pageActionName = 'tread-wishlist-event';
var getRemoveItemOptions = function getRemoveItemOptions(_ref) {
  var queryClient = _ref.queryClient,
    wishlistItemId = _ref.wishlistItemId,
    _ref$delayDataUpdate = _ref.delayDataUpdate,
    delayDataUpdate = _ref$delayDataUpdate === void 0 ? 0 : _ref$delayDataUpdate;
  return {
    mutationFn: function () {
      var _mutationFn = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _window;
        var defaultListId, token;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _getOptions.getDefaultListId)({
                queryClient: queryClient
              });
            case 1:
              defaultListId = _context.v;
              _context.n = 2;
              return (_window = window) === null || _window === void 0 || (_window = _window.webShellClient) === null || _window === void 0 || (_window = _window.identity) === null || _window === void 0 ? void 0 : _window.getAccessToken();
            case 2:
              token = _context.v;
              return _context.a(2, (0, _fetchClient.fetchClient)("".concat(process.env.NEXT_PUBLIC_API_HOST_NAME, "/buy/wishlists/v2/lists/").concat(defaultListId, "/items/").concat(wishlistItemId), {
                method: 'DELETE',
                headers: (0, _fetchClient.formatHeaders)({
                  token: token,
                  appId: _uxTreadDotcomConstants.DOTCOM_UX_ID
                })
              }, 'Error deleting items from wishlist.', {
                pageActionName: pageActionName
              }));
          }
        }, _callee);
      }));
      function mutationFn() {
        return _mutationFn.apply(this, arguments);
      }
      return mutationFn;
    }(),
    onMutate: function () {
      var _onMutate = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var defaultListId, wishlistItemsQueryOptions, currentWishlistItems, itemPageIndex, itemIndex, removedItem, optimisticallyRemoveItemFromWishlist, dataUpdateTimeoutId;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return (0, _getOptions.getDefaultListId)({
                queryClient: queryClient
              });
            case 1:
              defaultListId = _context3.v;
              _context3.n = 2;
              return queryClient.cancelQueries((0, _getQueryKey2["default"])({
                listId: defaultListId
              }));
            case 2:
              // saving data for onError
              wishlistItemsQueryOptions = (0, _getQueryKey["default"])({
                id: defaultListId
              });
              _context3.n = 3;
              return queryClient.getQueryData(wishlistItemsQueryOptions);
            case 3:
              currentWishlistItems = _context3.v;
              itemPageIndex = null;
              itemIndex = null;
              currentWishlistItems === null || currentWishlistItems === void 0 || currentWishlistItems.pages.forEach(function (page, pageIdx) {
                page.objects.forEach(function (item, itemIdx) {
                  if (item.id === wishlistItemId) {
                    itemPageIndex = pageIdx;
                    itemIndex = itemIdx;
                  }
                });
              });
              removedItem = currentWishlistItems.pages[itemPageIndex].objects[itemIndex];
              optimisticallyRemoveItemFromWishlist = /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
                  return _regenerator().w(function (_context2) {
                    while (1) switch (_context2.n) {
                      case 0:
                        queryClient.setQueryData(wishlistItemsQueryOptions, function (currentWishlist) {
                          if (currentWishlist) {
                            var _currentWishlist$page;
                            var newPagesArray = (_currentWishlist$page = currentWishlist === null || currentWishlist === void 0 ? void 0 : currentWishlist.pages.filter(function (page) {
                              return page != null;
                            }).map(function (page) {
                              var _page$objects$filter, _page$objects;
                              return _objectSpread(_objectSpread({}, page), {}, {
                                objects: (_page$objects$filter = page === null || page === void 0 || (_page$objects = page.objects) === null || _page$objects === void 0 ? void 0 : _page$objects.filter(function (item) {
                                  return item.id !== wishlistItemId;
                                })) !== null && _page$objects$filter !== void 0 ? _page$objects$filter : []
                              });
                            })) !== null && _currentWishlist$page !== void 0 ? _currentWishlist$page : [];
                            return _objectSpread(_objectSpread({}, currentWishlist), {}, {
                              pages: newPagesArray
                            });
                          }
                        });
                        _context2.n = 1;
                        return queryClient.invalidateQueries(wishlistItemsQueryOptions);
                      case 1:
                        return _context2.a(2);
                    }
                  }, _callee2);
                }));
                return function optimisticallyRemoveItemFromWishlist() {
                  return _ref2.apply(this, arguments);
                };
              }();
              dataUpdateTimeoutId = setTimeout(optimisticallyRemoveItemFromWishlist, delayDataUpdate);
              return _context3.a(2, {
                itemIndex: itemIndex,
                itemPageIndex: itemPageIndex,
                removedItem: removedItem,
                dataUpdateTimeoutId: dataUpdateTimeoutId
              });
          }
        }, _callee3);
      }));
      function onMutate() {
        return _onMutate.apply(this, arguments);
      }
      return onMutate;
    }(),
    onError: function () {
      var _onError = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(error, variables, _ref3) {
        var _currentWishlistItems;
        var itemIndex, itemPageIndex, removedItem, dataUpdateTimeoutId, defaultListId, currentWishlistItems, itemStillInWishlist;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              itemIndex = _ref3.itemIndex, itemPageIndex = _ref3.itemPageIndex, removedItem = _ref3.removedItem, dataUpdateTimeoutId = _ref3.dataUpdateTimeoutId;
              _context4.n = 1;
              return (0, _getOptions.getDefaultListId)({
                queryClient: queryClient
              });
            case 1:
              defaultListId = _context4.v;
              _context4.n = 2;
              return queryClient.fetchQuery((0, _getQueryKey["default"])({
                id: defaultListId
              }));
            case 2:
              currentWishlistItems = _context4.v;
              itemStillInWishlist = currentWishlistItems === null || currentWishlistItems === void 0 || (_currentWishlistItems = currentWishlistItems.pages) === null || _currentWishlistItems === void 0 ? void 0 : _currentWishlistItems.some(function (page) {
                var _page$objects2;
                return (_page$objects2 = page.objects) === null || _page$objects2 === void 0 ? void 0 : _page$objects2.some(function (item) {
                  return item.id === removedItem.id;
                });
              });
              if (itemStillInWishlist) {
                clearTimeout(dataUpdateTimeoutId);
              } else {
                // Item was already removed, add it back
                queryClient.setQueryData((0, _getQueryKey["default"])({
                  id: defaultListId
                }), function (currentWishlist) {
                  var _pageWithRemovedItem$, _pageWithRemovedItem$2;
                  var pageWithRemovedItem = currentWishlist === null || currentWishlist === void 0 ? void 0 : currentWishlist.pages[itemPageIndex];
                  var pageWithItemRestored = {
                    objects: [].concat(_toConsumableArray((pageWithRemovedItem === null || pageWithRemovedItem === void 0 || (_pageWithRemovedItem$ = pageWithRemovedItem.objects) === null || _pageWithRemovedItem$ === void 0 ? void 0 : _pageWithRemovedItem$.slice(0, itemIndex)) || []), [removedItem], _toConsumableArray((pageWithRemovedItem === null || pageWithRemovedItem === void 0 || (_pageWithRemovedItem$2 = pageWithRemovedItem.objects) === null || _pageWithRemovedItem$2 === void 0 ? void 0 : _pageWithRemovedItem$2.slice(itemIndex)) || [])),
                    pages: pageWithRemovedItem === null || pageWithRemovedItem === void 0 ? void 0 : pageWithRemovedItem.pages
                  };
                  if (currentWishlist !== null && currentWishlist !== void 0 && currentWishlist.pages) {
                    currentWishlist.pages[itemPageIndex] = pageWithItemRestored;
                  }
                  return currentWishlist;
                });
              }
              queryClient.invalidateQueries((0, _getQueryKey2["default"])({
                listId: defaultListId
              }));
            case 3:
              return _context4.a(2);
          }
        }, _callee4);
      }));
      function onError(_x, _x2, _x3) {
        return _onError.apply(this, arguments);
      }
      return onError;
    }(),
    onSuccess: function () {
      var _onSuccess = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var defaultListId;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _context5.n = 1;
              return (0, _getOptions.getDefaultListId)({
                queryClient: queryClient
              });
            case 1:
              defaultListId = _context5.v;
              queryClient.invalidateQueries((0, _getQueryKey2["default"])({
                listId: defaultListId
              }));
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      function onSuccess() {
        return _onSuccess.apply(this, arguments);
      }
      return onSuccess;
    }()
  };
};
var _default = exports["default"] = getRemoveItemOptions;